import { FlexRowAlignCenter } from "@/components/Flex";
import { iconSizes } from "@/utils/iconProps";
import { spacing } from "@/utils/spacing";
import { themeColors } from "@/utils/themeColors";
import Box from "@mui/material/Box";
import { ArrowRight } from "lucide-react";
import Image, { ImageProps } from "next/image";

const UserProgressDetailsCard = ({
    title,
    titleProps,
    icon,
    customIcon,
    color,
    progress,
    onClick,
    label,
    iconProps,
    containerStyle,
    progressProps,
}: {
    title: string;
    titleProps?: React.HTMLAttributes<HTMLHeadingElement>;
    customIcon?: React.ReactNode;
    icon?: string;
    color: string;
    progress: string;
    onClick?: () => void;
    label?: string;
    iconProps?: Partial<ImageProps>;
    containerStyle?: React.CSSProperties;
    progressProps?: React.HTMLAttributes<HTMLHeadingElement>;
}) => {
    return (
        <Box
            component={"div"}
            onClick={onClick}
            sx={{
                padding: spacing.MD,
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                borderRadius: "2rem",
                gap: spacing.MD,
                width: "100%",
                height: "fit-content",
                backgroundColor: themeColors.neutralWhite,
                color: themeColors.neutralBlack,
                textDecoration: "none",
                cursor: "pointer",
                "&:hover": {
                    outline: `1px solid ${themeColors.neutralBlack}`,
                },
                ...containerStyle,
            }}>
            <p className="heading5" {...titleProps} data-testid="auto-id-2d4b4a41-49e8-45ba-8f02-8f83f50dad6e">
                {title}
            </p>
            <FlexRowAlignCenter
                style={{
                    color: color,
                    gap: spacing.XS,
                }}>
                {customIcon || <Image src={icon} alt={title} width={40} height={40} {...iconProps} />}
                <p className="heading3" {...progressProps} data-testid="auto-id-d08c06e5-909f-47ae-ba72-08660875a725">
                    {progress}
                </p>
            </FlexRowAlignCenter>
            <FlexRowAlignCenter
                style={{ width: "100%", justifyContent: "space-between", display: label ? "flex" : "none" }}>
                <p className="bodyBold2" data-testid="auto-id-2f3a1abc-1a39-4bb9-8265-2c2acc94a142">
                    {label}
                </p>
                {onClick && <ArrowRight size={iconSizes.MD} strokeWidth={2} />}
            </FlexRowAlignCenter>
        </Box>
    );
};

export default UserProgressDetailsCard;
